import React from "react";
import { CheckCircle2Icon, XCircleIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { CtaButton } from "./CtaButton";
import { afterItems, beforeItems } from "../data/content";
export function BeforeAfter() {
  return <section className="w-full bg-canvas px-5 py-16 sm:py-20" data-id="element-39" data-mp="3ohue9oq21qas">
      <SectionHeading eyebrow="A More Structured Way to Approach BCM Faults" title={<>
            From Scattered Information… to a <span className="text-brand" data-id="element-41" data-mp="3jgohnft9xivz">Repeatable Diagnostic Workflow.</span>
          </>} data-id="element-40" data-mp="3sg1rwap82bhr" />
      <p className="mx-auto mt-5 max-w-2xl text-center text-lg leading-relaxed text-muted" data-id="element-42" data-mp="34s21xczqip48">
        Having more information doesn't always make the next decision easier. What you need is a way to organize that
        information and understand what it actually tells you.
      </p>

      <div className="mx-auto mt-10 grid max-w-5xl gap-5 md:grid-cols-2" data-id="element-43" data-mp="2vtgf35n8cnxn">
        <div className="overflow-hidden rounded-3xl border-2 border-alert/30 bg-white" data-id="element-44" data-mp="30pdr4zrgn84m">
          <div className="bg-alert px-6 py-4 text-center" data-id="element-45" data-mp="x2z9lbtl2h9h">
            <h3 className="font-display text-xl font-black uppercase text-white" data-id="element-46" data-mp="t3i3cg6c1g39">Before the Blueprint</h3>
          </div>
          <ul className="divide-y divide-alert/10 px-6 py-2" data-id="element-47" data-mp="171os96tb05qs">
            {beforeItems.map(item => <li key={item} className="flex gap-3 py-4 text-base leading-snug text-navy" data-id="element-48" data-mp="124ybeh9od64b">
                <XCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-alert" aria-hidden="true" data-id="element-49" data-mp="ef4044507pm6" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="overflow-hidden rounded-3xl border-2 border-cta/40 bg-white shadow-[0_20px_40px_-20px_rgba(22,163,74,0.45)]" data-id="element-50" data-mp="o4dq9egaey7n">
          <div className="bg-cta px-6 py-4 text-center" data-id="element-51" data-mp="jbkq73vrke1w">
            <h3 className="font-display text-xl font-black uppercase text-white" data-id="element-52" data-mp="3rsfg7irgq3yk">With the Blueprint</h3>
          </div>
          <ul className="divide-y divide-cta/10 px-6 py-2" data-id="element-53" data-mp="3msuj7dvus5oh">
            {afterItems.map(item => <li key={item} className="flex gap-3 py-4 text-base font-medium leading-snug text-navy" data-id="element-54" data-mp="1qpogm83dsxml">
                <CheckCircle2Icon className="mt-0.5 h-6 w-6 shrink-0 text-cta" aria-hidden="true" data-id="element-55" data-mp="1voj61svutkfo" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <p className="mx-auto mt-8 max-w-2xl text-center text-base leading-relaxed text-muted" data-id="element-56" data-mp="24h2xo9dqaor0">
        The goal isn't to replace your technical expertise or manufacturer-specific service information. It's to give
        your expertise a clearer structure, so you can approach each investigation with a repeatable process.
      </p>
      <div className="mt-10" data-id="element-57" data-mp="1guo313idqpce">
        <CtaButton data-id="element-58" data-mp="1lreippq9vixa">Yes! Show Me the System</CtaButton>
      </div>
    </section>;
}